/* eslint-disable max-len, no-param-reassign */
export default {
  data() {
    return {
      isOpenConfigColumn: false,
      idConfigColumn: 'configurationColumn',
      selectedColumn: null,
      selectedIndexColumn: null,
    };
  },

  methods: {
    setIconType(type) {
      const convertType = type.toLowerCase();
      let finalType = '';
      if (convertType === 'date' || convertType === 'mmmm dd, yyyy' || convertType === 'MMMM dd, yyyy' || convertType === 'dd-mmm-yyyy') {
        finalType = 'date';
      } else {
        finalType = convertType;
      }
      return finalType;
    },

    openConfigColumn(column, index) {
      if (this.selectedColumn) {
        this.toggleConfigurationColumn(false);

        setTimeout(() => {
          this.selectedColumn = column;
          this.selectedIndexColumn = index;
          this.toggleConfigurationColumn(true);
        }, 250);
      } else {
        this.selectedColumn = column;
        this.selectedIndexColumn = index;

        this.toggleConfigurationColumn(true);
      }
    },

    toggleConfigurationColumn(status) {
      if (status) {
        this.isOpenConfigColumn = true;

        setTimeout(() => {
          const element = document.getElementById(this.idConfigColumn);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfigColumn);
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenConfigColumn = false;
          this.selectedColumn = null;
          this.selectedIndexColumn = null;
        }, 200);
      }
    },

    deleteColumn(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this column ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.column.splice(index || this.selectedIndexColumn, 1);
          this.setChangesValueView(true);

          if (this.isOpenConfigColumn) this.toggleConfigurationColumn(false);
        }
      });
    },

    submitColumn(mode, params) {
      if (params.type === 'action_button') {
        if (this.dataSetup.action_buttons && this.dataSetup.action_buttons.length > 0) {
          if (mode === 'add') {
            Array.prototype.push.apply(this.dataSetup.action_buttons, params.action_buttons);
          } else {
            params.action_buttons.forEach((e) => {
              const findKeySame = this.dataSetup.action_buttons.find(f => f.key === e.key);
              const findKeySameIndex = this.dataSetup.action_buttons.findIndex(f => f.key === e.key);
              if (findKeySame) {
                this.dataSetup.action_buttons[findKeySameIndex] = e;
              } else {
                this.dataSetup.action_buttons.push(e);
              }
            });
          }
        } else {
          this.dataSetup.action_buttons = params.action_buttons;
        }
      }
      delete params.action_buttons;
      if (mode === 'add') {
        this.dataSetup.column.push(params);
      } else {
        this.dataSetup.column[this.selectedIndexColumn] = params;
      }
      this.toggleConfigurationColumn(false);
      this.setChangesValueView(true);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixSetupColumn.js